export const STOCK_UPDATE = "STOCK_UPDATE";
export const STOCK_UPDATE_SUCCESS = "STOCK_UPDATE_SUCCESS";
export const STOCK_UPDATE_FAILED = "STOCK_UPDATE_FAILED";